module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-144.f7ef18d4.svg";